<template>
  <v-dialog
    v-model="open"
    max-width="600"
    overlay-color="black"
    overlay-opacity="0.8"
  >
    <v-card>
      
      <v-card-title class="headline"> {{ title }} </v-card-title>
      <v-card-text class="px-6">
        <v-form
          id="admin-banner-form"
          @submit.prevent="submitAction"
          autocomplete="off"
        >
        <text-box
            label="Názov"
            :max="50"
            :cache="false"
            v-model="nazov"
          ></text-box>
          <text-box
            label="Titulok"
            :max="50"
            :cache="false"
            v-model="titulok"
          ></text-box>
          <text-box
            label="Info"
            :max="50"
            :cache="false"
            v-model="info"
          ></text-box>
          <text-box
            label="Text vľavo"
            :cache="false"
            :max="50"
            v-model="textVlavo"
          ></text-box>
          <text-box
            label="Text vpravo"
            :cache="false"
            :max="50"
            v-model="textVpravo"
          ></text-box>
          <text-box
            label="Presmerovanie URL"
            :cache="false"
            :url="true"
            :max="100"
            v-model="presmerovanieUrl"
          ></text-box>
          <date-picker
            placeholder="DD/MM/YYYY"
            label="Dátum do"
            v-model="datumDo"
            :cache="false"
          ></date-picker>
          <dynamic-combo
            ref="znacka"
            v-model="znacka"
            :cache="false"
            :multiple="true"
            data-id="liw_filip__admin_banner__cb_znacky"
            dynamic
            clearable
            lite
            autoload
          ></dynamic-combo>
          <dynamic-combo
            ref="rola"
            v-model="rola"
            :cache="false"
            :multiple="true"
            data-id="liw_filip__admin_banner__cb_role"
            dynamic
            clearable
            lite
            autoload
          ></dynamic-combo>
          <dynamic-combo
            ref="umiestnenia"
            v-model="id_umiestnenia_multi"
            :cache="false"
            :multiple="true"
            data-id="liw_filip__admin_banner__cb_umiestnenie"
            dynamic
            clearable
            lite
            autoload
          ></dynamic-combo>
          <div
            @drop.prevent="addDroppedFile"
            @dragover.prevent
            v-cloak
            class="pt-4"
          >
            <v-file-input
              ref="darkImage"
              label="Obrázok pozadia tmavá téma (rozlíšenie 1110x236)"
              prepend-icon="mdi-image-area"
              @change="onFileSelectDark"
              accept="image/png, image/jpeg, image/jpg"
            ></v-file-input>
            <v-file-input
            ref="darkMobileImage"
              class="pb-6"
              label="Obrázok pozadia pre mobil tmavá téma (rozlíšenie 343x310 / .svg)"
              prepend-icon="mdi-image-area"
              @change="onMobileFileSelectDark"
              accept="image/png, image/jpeg, image/jpg, image/svg+xml"
            ></v-file-input>
            <v-file-input
              ref="lightImage"
              label="Obrázok pozadia svetlá téma (rozlíšenie 1110x236)"
              prepend-icon="mdi-image-area"
              @change="onFileSelectLight"
              accept="image/png, image/jpeg, image/jpg"
            ></v-file-input>
            <v-file-input
              ref="lightMobileImage"
              class="pb-6"
              label="Obrázok pozadia pre mobil svetlá téma (rozlíšenie 343x310 / .svg)"
              prepend-icon="mdi-image-area"
              @change="onMobileFileSelectLight"
              accept="image/png, image/jpeg, image/jpg, image/svg+xml"
            ></v-file-input>
          </div>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn type="submit" class="btn-primary" form="admin-banner-form">
          Uložiť
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import protectedAxios from '../../auth/axios';
import TextBox from '../../components/basic/TextBox.vue';
import DynamicCombo from '../../components/basic/DynamicCombo.vue';
import DatePicker from '../../components/basic/DatePicker.vue';
import moment from 'moment';

export default {
  components: {
    TextBox,
    DynamicCombo,
    DatePicker,
  },
  props: {
    action: {
      type: String,
      default: '',
    },
    entityId: Number,
  },
  computed: {
    title: {
      get() {
        switch (this.action) {
          case 'create':
            return 'Vytvorenie';

          case 'update':
            return 'Upravenie';

          default:
            return '';
        }
      },
      set() {},
    },
  },
  methods: {
    onFileSelectDark(files) {
      if (!files) return;
      this.obrazokTmavy = files;
    },
    onMobileFileSelectDark(files) {
      if (!files) return;
      this.obrazokMobilTmavy = files;
    },
    onFileSelectLight(files) {
      if (!files) return;
      this.obrazokSvetly = files;
    },
    onMobileFileSelectLight(files) {
      if (!files) return;
      this.obrazokMobilSvetly = files;
    },
    addDroppedFileDark(e) {
      this.obrazokTmavy = e.dataTransfer.files[0];
    }, 
    addDroppedMobileFileDark(e) {
      this.obrazokMobilTmavy = e.dataTransfer.files[0];
    },
    addDroppedFileLight(e) {
      this.obrazokSvetly = e.dataTransfer.files[0];
    },
    addDroppedMobileFileLight(e) {
      this.obrazokMobilSvetly = e.dataTransfer.files[0];
    },

    submitAction() {
      switch (this.action) {
        case 'create':
          this.createBanner('banner');
          break;

        case 'update':
          this.updateBanner('banner/' + this.entityId);
          break;

        default:
          break;
      }
    },

    async openDialog(){
      this.open = true;
      this.$nextTick(()=>{
        Promise.all([
          this.$refs.rola.loadData(),
          this.$refs.znacka.loadData(),
          this.$refs.umiestnenia.loadData()
        ]).then(async () =>{
          this.clearData();
          if(this.action == 'update'){
            await this.getById();
          }
        })
      });
    },

    createBanner(url) {
      const data = this.setFormData();

      protectedAxios
        .post(url, data, { 'Content-Type': 'multipart/form-data' })
        .then(res => {
          this.open = false;
          this.clearData();
          this.$emit('successEvent');
        })
        .catch(e => {
          console.error(e);
        });
    },

    updateBanner(url) {
      const data = this.setFormData();

      protectedAxios
        .put(url, data, { 'Content-Type': 'multipart/form-data' })
        .then(res => {
          this.open = false;
          this.clearData();
          this.$emit('successEvent');
        })
        .catch(e => {
          console.error(e);
        });
    },

    async getById() {
      return await protectedAxios
        .get('banner/' + this.entityId)
        .then(res => {
          console.log(res)
          this.nazov = res.data.nazov;
          this.titulok = res.data.text_vlavo_titulok;
          this.info = res.data.text_vlavo_info;
          this.textVlavo = res.data.text_vlavo;
          this.textVpravo = res.data.text_vpravo;
          this.presmerovanieUrl = res.data.presmerovanie_url;
          this.znacka = res.data.znacka.split(',').map(Number);
          if(res.data.datum_do){
            this.datumDo = moment(res.data.datum_do).format('YYYY-MM-DD');
          }

          this.rola = res.data.rola.split(',').map(Number);
          this.znacka = res.data.znacka.split(',').map(Number);
          this.id_umiestnenia_multi = res.data.id_umiestnenia_multi.split(',').map(Number);
        })
        .catch(e => {
          console.error(e);
        });
    },

    setFormData() {
      const postData = new FormData();
      Object.keys(this.$data).forEach(key => {
        if(key != 'loading' && key != 'open')
          postData.append(key, this.$data[key]);
      });
      return postData;
    },

    clearData() {
      this.nazov = '';
      this.titulok = '';
      this.info = '';
      this.textVlavo = '';
      this.textVpravo = '';
      this.presmerovanieUrl = '';
      this.obrazokTmavy = null;
      this.obrazokMobilTmavy = null;
      this.obrazokSvetly = null;
      this.obrazokMobilSvetly = null;
      this.znacka = [];
      this.rola = [];
      this.id_umiestnenia_multi = [];
      this.datumDo = '';
      this.$refs.darkImage.reset();
      this.$refs.darkMobileImage.reset();
      this.$refs.lightImage.reset();
      this.$refs.lightMobileImage.reset();
    },
  },

  mounted() {
  },
  data() {
    return {
      open: false,
      nazov: '',
      titulok: '',
      info: '',
      textVlavo: '',
      textVpravo: '',
      presmerovanieUrl: '',
      obrazokTmavy: null,
      obrazokMobilTmavy: null,
      obrazokSvetly: null,
      obrazokMobilSvetly: null,
      znacka: [],
      rola: [],
      id_umiestnenia_multi:[],
      datumDo: '',
    };
  },
};
</script>
